export interface IApiResponse<T> {
    count: number
    next: string | null
    previous: string | null
    results: T[] | []
}

export class ApiResponse<T> implements IApiResponse<T> {
    constructor(
        public count = 0,
        public next = null,
        public previous = null,
        public results = []
    ) {}
}
